import { useGLTF } from '@react-three/drei';
import { useMemo } from 'react';

export function WoodOutlined(props) {
  const { nodes, materials } = useGLTF('/WoodOutlined.glb');

  const material = useMemo(() => {
    const m = materials['Material.001'].clone();

    m.transparent = props.transparent ?? false;
    m.opacity = props.opacity ?? 1;

    if (props.transparent) {
      m.depthWrite = false;
    }

    return m;
  }, [materials, props.transparent, props.opacity]);
  return (
    <group dispose={null}>
      <mesh geometry={nodes.Cube.geometry} position={props.position} material={material} scale={props.scale} rotation={[0, props.rotation || 0, 0]} renderOrder={props.transparent ? 10 : 0} />
    </group>
  );
}
